module.exports = __webpack_public_path__ + "static/sugarwod-8b196cb46c86d91d4fd9c5ea2d0573b1.png";